import { BaseService, Unauthorized, UnexpectedError } from './base-service';

export class CompanyService extends BaseService {
    async getSimplifiedCompanies(): Promise<DropdownResource[]> {
        const token = await this.getToken();
        const res = await fetch(`${this.centralEndpoint}/internal-app/simplified-companies`, {
            method: 'GET',
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (res.status == 401) {
            throw new Unauthorized();
        } else if (res.status != 200) {
            throw new UnexpectedError();
        }
        return res.json();
    }
}

export const companyService = new CompanyService();
